module.exports = __webpack_public_path__ + "static/img/erweima.e300056.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/erweima.png
// module id = dWeS
// module chunks = 29